<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-md-12 d-flex flex-wrap justify-content-between align-items-start gap-3">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Cadastro de Pessoa</h1>
            <p class="welcome-message">
              <button mat-icon-button routerLink="../">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Preencha os dados do registro
            </p>
          </div>
        </div>
        @if (isEditMode && idPessoa) {
        <div>
          <button mat-stroked-button type="button" class="btn-secondary" [matMenuTriggerFor]="acoesMenu"
            [disabled]="!isPessoaGravadaCarregada">
            <span>Ações</span>
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #acoesMenu="matMenu" xPosition="before">
            @let motivoCrm = getMotivoCrmIndisponivel(listIdTipoContatoGravado);
            <span [matTooltip]="motivoCrm" matTooltipPosition="left">
              <button mat-menu-item type="button" [disabled]="!!motivoCrm" [attr.aria-label]="motivoCrm || null"
                (click)="abrirOportunidadesCrm()">
                <mat-icon class="material-symbols-outlined">forum</mat-icon>
                <span>Ver oportunidades no CRM</span>
              </button>
            </span>
            <span [matTooltip]="motivoCrm" matTooltipPosition="left">
              <button mat-menu-item type="button" [disabled]="!!motivoCrm" [attr.aria-label]="motivoCrm || null"
                (click)="incluirOportunidadeCrm()">
                <mat-icon class="material-symbols-outlined">add_comment</mat-icon>
                <span>Incluir oportunidade no CRM</span>
              </button>
            </span>
            <mat-divider></mat-divider>
            @let motivoOrcamentoPedido = getMotivoOrcamentoPedidoIndisponivel(listIdTipoContatoGravado);
            @let motivoNotaFiscal = getMotivoNotaFiscalIndisponivel(listIdTipoContatoGravado);
            <span [matTooltip]="motivoOrcamentoPedido" matTooltipPosition="left">
              <button mat-menu-item type="button" [disabled]="!!motivoOrcamentoPedido"
                [attr.aria-label]="motivoOrcamentoPedido || null" (click)="incluirOrcamento()">
                <mat-icon class="material-symbols-outlined">request_quote</mat-icon>
                <span>Incluir orçamento</span>
              </button>
            </span>
            <span [matTooltip]="motivoOrcamentoPedido" matTooltipPosition="left">
              <button mat-menu-item type="button" [disabled]="!!motivoOrcamentoPedido"
                [attr.aria-label]="motivoOrcamentoPedido || null" (click)="criarPedidoVenda()">
                <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>
                <span>Criar pedido de venda</span>
              </button>
            </span>
            <span [matTooltip]="motivoNotaFiscal" matTooltipPosition="left">
              <button mat-menu-item type="button" [disabled]="!!motivoNotaFiscal" [attr.aria-label]="motivoNotaFiscal || null"
                (click)="criarNotaFiscal()">
                <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
                <span>Criar nota fiscal</span>
              </button>
            </span>
            <mat-divider></mat-divider>
            <button mat-menu-item type="button" (click)="abrirUltimasVendas()">
              <mat-icon class="material-symbols-outlined">point_of_sale</mat-icon>
              <span>Consultar últimas vendas</span>
            </button>
            <button mat-menu-item type="button" (click)="abrirUltimasCompras()">
              <mat-icon class="material-symbols-outlined">local_shipping</mat-icon>
              <span>Consultar últimas compras</span>
            </button>
            <span matTooltip="Em definição" matTooltipPosition="left">
              <button mat-menu-item type="button" disabled aria-label="Em definição">
                <mat-icon class="material-symbols-outlined">home_repair_service</mat-icon>
                <span>Consultar últimos serviços</span>
              </button>
            </span>
          </mat-menu>
        </div>
        }
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="salvar()">
      <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

      <!-- Seção 1: Informações Básicas -->
      <div class="section-container" id="info-basica">
        <div class="section-title">
          <mat-icon>person</mat-icon>
          <span>Informações Básicas</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <label class="d-block mb-2 small">Tipo de Pessoa</label>
            <mat-radio-group formControlName="idTipoPessoa" class="radio-group">
              @for (tipo of listaTipoPessoa; track tipo.id) {
              <mat-radio-button [value]="tipo.id">{{ tipo.descricao }}</mat-radio-button>
              }
            </mat-radio-group>
          </div>
          <div class="col-12 col-md-6 status-toggle">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo"></mat-slide-toggle>
            <span>{{ form.get('isAtivo')?.value ? 'Ativo' : 'Inativo' }}</span>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CPF</mat-label>
              <input matInput formControlName="cpf" [mask]="masks.cpf" />
              @if (form.get('cpf')?.hasError('required')) {
              <mat-error>CPF é obrigatório para pessoa física</mat-error>
              } @else if (form.get('cpf')?.invalid) {
              <mat-error>Informe um CPF válido</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CNPJ</mat-label>
              <input matInput formControlName="cnpj" (blur)="consultarCnpj(form.get('cnpj')?.value)"
                [mask]="masks.cnpj" />
              @if (isLoadingCnpj) {
              @if (isLoadingCnpj) {
              <mat-spinner class="inline-loading" matSuffix [diameter]="20"></mat-spinner>
              }
              } @else {
              <mat-icon matSuffix class="clickable-icon"
                (click)="consultarCnpj(form.get('cnpj')?.value)">search</mat-icon>
              }
              @if (form.get('cnpj')?.hasError('required')) {
              <mat-error>CNPJ é obrigatório para pessoa jurídica</mat-error>
              } @else if (form.get('cnpj')?.invalid) {
              <mat-error>Informe um CNPJ válido</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 col-md-8">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Documento Estrangeiro</mat-label>
              <input matInput formControlName="documentoEstrangeiro" />
              @if (form.get('documentoEstrangeiro')?.hasError('required')) {
              <mat-error>Documento é obrigatório para pessoa estrangeira</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            @if (listaPaises) {
            <app-select-pesquisavel [control]="idPais" [offlineList]="listaPaises" label="País" idField="id"
              nameField="descricao">
            </app-select-pesquisavel>
            }
          </div>

          <div class="col-12 col-md-8">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome / Razão Social</mat-label>
              <input matInput formControlName="nome" required />
              @if (form.get('nome')?.hasError('required')) {
              <mat-error>Nome é obrigatório</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome Fantasia</mat-label>
              <input matInput formControlName="nomeFantasia" />
              @if (form.get('nomeFantasia')?.hasError('required')) {
              <mat-error>Informe o nome fantasia</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipos de Contato</mat-label>
              <mat-select formControlName="listIdTipoContato" multiple required>
                @for (tipo of listaTipoContato; track tipo.id) {
                <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Telefone</mat-label>
              <mat-icon matPrefix class="me-2 text-secondary">phone</mat-icon>
              <input matInput formControlName="telefone" [mask]="masks.phone" />
              @if (form.get('telefone')?.hasError('required')) {
              <mat-error>Informe o telefone</mat-error>
              } @else if (form.get('telefone')?.invalid) {
              <mat-error>Informe um telefone válido</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Email NF-e</mat-label>
              <mat-icon matPrefix class="me-2 text-secondary">email</mat-icon>
              <input matInput formControlName="emailNFe" required />
              @if (form.get('emailNFe')?.hasError('required')) {
              <mat-error>Email é obrigatório</mat-error>
              }
              @if (form.get('emailNFe')?.hasError('email')) {
              <mat-error>Email inválido</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Website</mat-label>
              <mat-icon matPrefix class="me-2 text-secondary">language</mat-icon>
              <input matInput formControlName="website" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Seção 2: Endereço e Contato -->
      <div class="section-container" id="endereco">
        <div class="section-title">
          <mat-icon>location_on</mat-icon>
          <span>Endereços e Contatos</span>
        </div>

        <p>Endereço Principal</p>
        <div class="row">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>CEP</mat-label>
              <input matInput formControlName="cep" (blur)="buscarCep()" [mask]="masks.cep" />
              @if (isLoadingCep) {
              <mat-spinner class="inline-loading" matSuffix [diameter]="20"></mat-spinner>
              } @else {
              <mat-icon matSuffix class="clickable-icon" (click)="buscarCep()">search</mat-icon>
              }
              @if (form.get('cep')?.hasError('required')) {
              <mat-error>Informe o CEP</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Endereço</mat-label>
              <input matInput formControlName="logradouro" />
              @if (form.get('logradouro')?.hasError('required')) {
              <mat-error>Informe o endereço</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Número</mat-label>
              <input matInput formControlName="numero" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Complemento</mat-label>
              <input matInput formControlName="complemento" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Bairro</mat-label>
              <input matInput formControlName="bairro" />
              @if (form.get('bairro')?.hasError('required')) {
              <mat-error>Informe o bairro</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            @if (listaUf) {
            <app-select-pesquisavel [control]="idUnidadeFederativa" [offlineList]="listaUf" label="UF" idField="id"
              nameField="descricao" (selectionChange)="changeUnidadeFederativa($event)">
            </app-select-pesquisavel>
            }
          </div>
          <div class="col-12 col-md-5">
            <app-select-pesquisavel [control]="idMunicipio" [apiUrl]="urlMunicipio" label="Município"
              idField="idMunicipio" nameField="nome" [preloadedOptions]="preloadedCity"
              (selectionChange)="changeCidade($event)">
            </app-select-pesquisavel>
          </div>
        </div>

        <div class="mb-3">
          <mat-checkbox formControlName="hasBillingAddress">Possui endereço de cobrança diferente do endereço
            principal</mat-checkbox>
        </div>

        @if (showBillingAddress) {
        <div>
          <p>Endereço de Cobrança</p>
          <div class="row">
            <div class="col-12 col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>CEP</mat-label>
                <input matInput formControlName="cepCobranca" (blur)="buscarCep(true)" [mask]="masks.cep" />
                @if (isLoadingCep) {
                <mat-spinner class="inline-loading" matSuffix [diameter]="20"></mat-spinner>
                } @else {
                <mat-icon matSuffix class="clickable-icon" (click)="buscarCep(true)">search</mat-icon>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Endereço</mat-label>
                <input matInput formControlName="logradouroCobranca" />
              </mat-form-field>
            </div>
            <div class="col-12 col-md-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Número</mat-label>
                <input matInput formControlName="numeroCobranca" />
              </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="complementoCobranca" />
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="bairroCobranca" />
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <app-select-pesquisavel [control]="idUnidadeFederativaCobranca" [offlineList]="listaUf" label="UF"
                idField="id" nameField="descricao" (selectionChange)="changeUnidadeFederativa($event, true)">
              </app-select-pesquisavel>
            </div>
            <div class="col-12 col-md-5">
              <app-select-pesquisavel [control]="idMunicipioCobranca" [apiUrl]="urlMunicipioCobranca" label="Município"
                idField="idMunicipio" nameField="nome" [preloadedOptions]="preloadedBillingCity"
                (selectionChange)="changeCidade($event, true)">
              </app-select-pesquisavel>
            </div>
          </div>
        </div>
        }

        <!-- Contatos Adicionais -->
        <div formArrayName="contatosAdicionais">
          <div class="d-flex justify-content-between align-items-center mb-2 mt-4">
            <p>Contatos Adicionais</p>
            <button type="button" mat-button (click)="addContato()">
              <mat-icon>add</mat-icon> Adicionar
            </button>
          </div>

          @for (contato of contatosAdicionais.controls; track contato; let i = $index) {
          <div [formGroupName]="i" class="contact-row-wrapper">
            <div class="row">
              <div class="col-10 col-lg-11">
                <div class="row">
                  <div class="col-12 col-sm-6 col-lg-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Nome</mat-label>
                      <input matInput formControlName="nome" required placeholder="Nome" />
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-2">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Cargo</mat-label>
                      <input matInput formControlName="cargo" placeholder="Cargo" />
                    </mat-form-field>
                  </div>
                  <div class="col-6 col-lg-2">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Telefone</mat-label>
                      <input matInput formControlName="telefone" placeholder="(00) 0000-0000" [mask]="masks.phone" />
                    </mat-form-field>
                  </div>
                  <div class="col-6 col-lg-2">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Celular</mat-label>
                      <input matInput formControlName="celular" placeholder="(00) 0000-0000" [mask]="masks.phone" />
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="email" placeholder="Email" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-2 col-lg-1 delete-col">
                <button type="button" mat-icon-button (click)="removeContato(i)" matTooltip="Remover contato">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
          }
          @if (contatosAdicionais.length === 0) {
          <app-empty-state icon="contacts" title="Nenhum contato adicional cadastrado"
            subtitle="Contatos adicionais permitem cadastrar outras pessoas de contato, como financeiro, comercial ou responsável técnico.">
          </app-empty-state>
          }
        </div>
      </div>

      <!-- Seção 3: Dados Fiscais -->
      <div class="section-container" id="fiscal">
        <div class="section-title">
          <mat-icon>receipt_long</mat-icon>
          <span>Dados Fiscais</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            @if (listaIndicadorInscricaoEstadual) {
            <app-select-pesquisavel [control]="idIndicadorInscricaoEstadual" [offlineList]="listaIndicadorInscricaoEstadual"
              label="Tipo Contribuinte" idField="id" nameField="descricao" [isOptional]="false">
            </app-select-pesquisavel>
            }
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição Estadual</mat-label>
              <input matInput formControlName="inscricaoEstadual" />
              @if (form.get('inscricaoEstadual')?.hasError('required')) {
              <mat-error>Informe a inscrição estadual</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição Municipal</mat-label>
              <input matInput formControlName="inscricaoMunicipal" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            @if (listaRegimeTributario) {
            <app-select-pesquisavel [control]="idRegimeTributario" [offlineList]="listaRegimeTributario"
              label="Regime Tributário" idField="id" nameField="descricao" [isOptional]="!isObrigatorio('id_regime_tributario')">
            </app-select-pesquisavel>
            }
          </div>
          <div class="col-12 col-md-4">
            @if (listaTipoTributario) {
            <app-select-pesquisavel [control]="idTipoTributario" [offlineList]="listaTipoTributario"
              label="Tipo Tributário" idField="id" nameField="descricao" [isOptional]="true">
            </app-select-pesquisavel>
            }
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Inscrição Suframa</mat-label>
              <input matInput formControlName="inscricaoSuframa" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-6">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isConsumidorFinal">Consumidor
                Final</mat-slide-toggle>
              <span class="info-text">
                Marque esta opção caso este cliente seja o consumidor final nas operações comerciais
              </span>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isContribuinteIbsCbs">Contribuinte de
                IBS/CBS</mat-slide-toggle>
              <span class="info-text">Marque caso seja contribuinte de
                impostos sobre bens e serviços</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 4: Dados Complementares -->
      <div class="section-container" id="complementar">
        <div class="section-title">
          <mat-icon>description</mat-icon>
          <span>Dados Complementares</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data Cadastro</mat-label>
              <input matInput [matDatepicker]="pickerCadastro" formControlName="datetimeInclusao" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerCadastro" disabled></mat-datepicker-toggle>
              <mat-datepicker #pickerCadastro></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data de Nascimento</mat-label>
              <input matInput [matDatepicker]="pickerNascimento" formControlName="dataNascimento"
                (input)="onDateInput($event)" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerNascimento"></mat-datepicker-toggle>
              <mat-datepicker #pickerNascimento></mat-datepicker>
              @if (form.get('dataNascimento')?.hasError('required')) {
              <mat-error>Informe a data de nascimento</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Status CRM</mat-label>
              <mat-select formControlName="statusCrm">
                @for (tipo of listaStatusCrm; track tipo.id) {
                <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Limite de Crédito</mat-label>
              <input matInput type="text" formControlName="limiteCredito" placeholder="0,00"
                [currencyMask]="currencyMask" [required]="isObrigatorio('limite_credito')" />
              @if (form.get('limiteCredito')?.hasError('valorMaiorQueZero')) {
              <mat-error>Informe um limite de crédito maior que zero</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            @if (listaVendedores) {
            <app-select-pesquisavel [control]="idVendedorResponsavel" [offlineList]="listaVendedores"
              label="Vendedor Responsável" idField="id" nameField="descricao" [isOptional]="!isObrigatorio('id_vendedor')">
            </app-select-pesquisavel>
            }
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Condição de pagamento</mat-label>
              <input matInput type="text" formControlName="condicaoPagamento" placeholder="30 60" />
            </mat-form-field>
            <div class="condicao-pagamento-hint">
              Número de parcelas ou prazos. Exemplos: <b>30 60</b>, <b>3x</b> ou <b>15 +2x</b>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <app-select-pesquisavel [control]="listIdListaPreco" [offlineList]="listaListaPreco" [multiple]="true"
              label="Lista de Preço" idField="id" nameField="descricao" [isOptional]="true">
            </app-select-pesquisavel>
          </div>

          <div class="col-12">
            <h4 class="subsection-title">Observações</h4>
            <div class="editor-container">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" formControlName="observacoesGerais" placeholder="Escreva as observações...">
              </ngx-editor>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção 5: Anexos -->
      <div class="section-container" id="anexos">
        <div class="section-title">
          <mat-icon>attach_file</mat-icon>
          <span>Anexos</span>
        </div>

        <div class="upload-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <input type="file" #fileInput multiple (change)="onFileSelected($event)" style="display: none" />

          <div class="upload-dropzone" (click)="fileInput.click()">
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <p class="upload-text"><strong>Clique para enviar</strong> ou arraste e solte</p>
            <p class="upload-hint">Limitado a 2mb por arquivo (Máximo 10MB Total)</p>
          </div>
        </div>

        <!-- Lista de Arquivos -->
        @if (anexos.length > 0) {
        <div class="file-list mt-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <p class="mb-0 font-weight-bold">Arquivos Selecionados:</p>
            <button type="button" mat-button (click)="limparAnexos()">
              <mat-icon>delete_sweep</mat-icon> Limpar Todos
            </button>
          </div>
          @for (file of anexos; track file; let i = $index) {
          <div class="file-item">
            <div class="file-info">
              <mat-icon class="file-icon">description</mat-icon>
              <div class="file-details">
                <span class="file-name">{{ file.nomeOriginal }}</span>
                <span class="file-size">{{ formatBytes(file.tamanhoBytes) }}</span>
              </div>
            </div>
            <div>
              <button mat-icon-button type="button" (click)="downloadAnexo(i)" matTooltip="Download arquivo"
                class="close-icon">
                <mat-icon>download</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="removeAnexo(i)" matTooltip="Remover arquivo"
                class="close-icon">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          }
        </div>
        }
      </div>
    </form>
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>